<template>
  <base-modal :modal-id="modalId" :btnClose="false">
    <template v-slot:modal-body>
      <div>
        <h4 class="txt_center_margin_auto">
          {{ _T('Pick your country below') }}
        </h4>
        <hr />
        <div class="country-selection-container container">
          <div
            v-for="(country, i) in availableCountries"
            :key="country.country_code + i"
            @click="setCountry(country.country_code)"
            class="country-selection"
            :class="selectedCountry == country.country_code ? 'active' : ''"
            :title="country.name"
          >
            <img
              :src="'/images/country-icon/' + country.country_code + '.png'"
              :alt="country.country_code"
            />
            <p>{{ country.name }}</p>
          </div>
        </div>
      </div>
    </template>
    <hr />
    <template v-slot:modal-footer>
      <div class="btn-action">
        <button
          type="button"
          class="btn btn-danger cancel-announce color-text-invert color-button"
          data-dismiss="modal"
          @click="$bvModal.hide(modalId)"
        >
          {{ _T('Close') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/Modals/BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'CountrySelectionModal',
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters(['_T', 'availableCountries']),
  },
  methods: {
    setCountry(country) {
      this.selectedCountry = country
      this.$store.dispatch('setSelectedCountry', country)
      this.$bvModal.hide(this.modalId)
    },
  },
  data() {
    return {
      process: 'country-selection',
      modalId: 'country-selection-modal',
      selectedCountry: '',
    }
  },
}
</script>

<style lang="scss" scoped>
.btn-action {
  display: -ms-inline-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: $px24;
}
.txt_center_margin_auto {
  text-align: center;
  margin: auto;
}

.country-selection-container {
  display: grid;
  gap: $px15;
  grid-template-columns: repeat(auto-fill, minmax($px110, 1fr));
  grid-auto-rows: minmax($px110, auto);
  .country-selection {
    text-align: center;
    box-shadow: 0 $px5 $px10 rgba(1, 1, 1, 0.2);
    padding: $px8;
    min-width: $px125;
    max-width: $px125;
    border-radius: $px4;
    img {
      height: $px50;
    }
    &:hover {
      box-shadow: 0 $px2 $px5 rgba(1, 1, 1, 0.2);
      cursor: pointer;
    }
    @media (max-width: 575px) {
      margin-top: $px10;
    }
    p {
      margin: 0 !important;
    }
  }

  .active {
    border: $px3 solid #28a745 !important;
  }
}
</style>

<style lang="scss">
#country-selection-modal___BV_modal_header_ {
  padding: 0 !important;
}
</style>
